/*!
 * CardsView - Vue en cartes riches (image/header, titre, badge, métadonnées structurées, description et actions)
 */

import CardView from './CardView';

export default class CardsView extends CardView {
    constructor(plugin, name = 'cards') {
        super(plugin, name);
    }

    createContainer(element) {
        const myself = this.plugin;
        const conf = myself.getViewConfig('cards') || myself.getViewConfig('card') || {};
        this.container = $('<div class="iv__cards-grid"></div>');
        myself.container = this.container;

        // Configuration dynamique de la grille via template
        if (conf.cols || conf.columns) {
            const cols = conf.cols || conf.columns;
            const gap = conf.gap !== undefined ? (typeof conf.gap === 'number' ? conf.gap + 'px' : conf.gap) : '20px';
            this.container.css({
                'display': 'grid',
                'grid-template-columns': `repeat(${cols}, 1fr)`,
                'gap': gap
            });
        } else if (conf.width || conf.size) {
            const minW = typeof (conf.width || conf.size) === 'number' ? (conf.width || conf.size) + 'px' : (conf.width || conf.size);
            const gap = conf.gap !== undefined ? (typeof conf.gap === 'number' ? conf.gap + 'px' : conf.gap) : '20px';
            this.container.css({
                'display': 'grid',
                'grid-template-columns': `repeat(auto-fill, minmax(${minW}, 1fr))`,
                'gap': gap
            });
        }

        myself.containerView.addClass('iv__view iv__view--cards view view-cards');
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }
        return this.container;
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        const conf = myself.getViewConfig('cards') || myself.getViewConfig('card') || {};
        const cardWidth = conf.width || conf.size || 280;
        const imageHeight = conf.height || Math.round(cardWidth * 0.58);

        myself.viewItemThumbsMode = false;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        // 1. Image / Médias
        let imageCode = '';
        const hasCustomThumb = !!(data.thumb || data.logo || data.preview || data.image);
        const resolvedShape = this.getItemShape(data);
        const shapeCls = (resolvedShape && resolvedShape !== 'default') ? ' ico__img--' + resolvedShape : '';

        if (data.html && !data.thumb) {
            imageCode = '<div class="iv__item__html">' + data.html + '</div>';
        } else if (data.thumb) {
            imageCode = myself.renderIconImage('thumb', data.thumb, data, 'thumb');
        } else if (data.logo) {
            imageCode = myself.renderIconImage('logo', data.logo, data, 'logo');
        } else if (data.preview && typeof data.preview === 'string' && (data.preview.startsWith('http') || data.preview.startsWith('/'))) {
            imageCode = '<img src="' + data.preview + '" class="ico__img' + shapeCls + '" alt="" loading="lazy" />';
        } else if (data.image) {
            imageCode = '<img src="' + data.image + '" class="ico__img' + shapeCls + '" alt="" loading="lazy" />';
        } else if (data.icon) {
            imageCode = '<div class="iv__card__icon-wrap">' + myself.renderIconImage(48, data.icon, data, 'img') + '</div>';
        }

        // 2. Actions boutons
        const codeActions = [];
        const actionsConfig = myself.getViewActions('cards') || myself.getViewActions('card');
        if (actionsConfig && actionsConfig.length && data.actions) {
            $.each(actionsConfig, (i, column) => {
                if (column.type !== 'action' && column.type !== 'actions') return;
                const actName = column.name;
                const action = data.actions[actName];
                if (action) {
                    const buttonIcon = myself.renderIconImage('small', action.icon);
                    codeActions.push('<button class="action--default action iv__card__action-btn" title="' + (action.label || actName) + '" data-action="' + actName + '">' + buttonIcon + '</button>');
                }
            });
        } else if (data.actions && !data.special) {
            // Prendre les actions par défaut disponibles
            const primaryActions = ['open', 'browse', 'edit', 'download', 'delete'];
            $.each(primaryActions, (idx, actName) => {
                const action = data.actions[actName];
                if (action) {
                    const buttonIcon = myself.renderIconImage('small', action.icon);
                    codeActions.push('<button class="action--default action iv__card__action-btn" title="' + (action.label || actName) + '" data-action="' + actName + '">' + buttonIcon + '</button>');
                }
            });
        }

        // 3. Badges (statut, type, catégorie, rôle)
        let badgesHtml = '';
        const statusVal = (data.data && data.data.status !== undefined) ? data.data.status : data.status;
        if (statusVal) {
            const statusClass = (statusVal === 'active' || statusVal === 'published' || statusVal === 'success') ? 'badge--success'
                : (statusVal === 'draft' || statusVal === 'warning' || statusVal === 'pending') ? 'badge--warning'
                : (statusVal === 'scheduled' || statusVal === 'info') ? 'badge--info'
                : 'badge--default';
            const statusLabel = (statusVal === 'published') ? 'Publié'
                : (statusVal === 'draft') ? 'Brouillon'
                : (statusVal === 'scheduled') ? 'Planifié'
                : (statusVal === 'active') ? 'Actif'
                : (statusVal === 'inactive') ? 'Inactif'
                : statusVal;
            badgesHtml += '<span class="badge badge--xs ' + statusClass + '">' + statusLabel + '</span>';
        }

        const groupVal = (data.data && data.data.groupName !== undefined) ? data.data.groupName : (data.groupName || data.category);
        if (groupVal) {
            badgesHtml += '<span class="iv__card__tag">' + groupVal + '</span>';
        }

        // 4. Champs de métadonnées (date, courriel, détails, etc.)
        let fieldsToUse = myself.getViewFields('cards') || myself.getViewFields('card');
        const metaRows = [];

        if (fieldsToUse && fieldsToUse.length) {
            $.each(fieldsToUse, (i, field) => {
                const fieldName = (typeof field === 'object') ? (field.data || field.name || field.field) : field;
                const fieldLabel = (typeof field === 'object' && field.label) ? field.label : '';
                const rawVal = (data.data && data.data[fieldName] !== undefined) ? data.data[fieldName] : data[fieldName];

                if (rawVal !== undefined && rawVal !== null && rawVal !== '' && rawVal != data.label) {
                    const renderedVal = myself.renderSubdata(rawVal, null, null, data);
                    metaRows.push('<div class="iv__card__meta-item">'
                        + (fieldLabel ? '<span class="iv__card__meta-label">' + fieldLabel + ':</span> ' : '')
                        + '<span class="iv__card__meta-val">' + renderedVal + '</span>'
                        + '</div>');
                }
            });
        } else {
            // Extraction automatique des champs pertinents
            const tableCols = myself.getViewColumns('table');
            if (tableCols && tableCols.length) {
                $.each(tableCols, (i, col) => {
                    if (col.type === 'action' || col.type === 'actions' || col.type === 'icon' || col.type === 'label') return;
                    if (metaRows.length >= 4) return; // Limiter pour garder la carte lisible

                    const colName = col.name;
                    if (!colName || colName === 'status') return;

                    const rawVal = (data.data && data.data[colName] !== undefined) ? data.data[colName] : data[colName];
                    if (rawVal !== undefined && rawVal !== null && rawVal !== '') {
                        let formatted = rawVal;
                        if (col.format || col.type) {
                            formatted = myself.formatCellValue(rawVal, col, data);
                        }
                        metaRows.push('<div class="iv__card__meta-item">'
                            + (col.label ? '<span class="iv__card__meta-label">' + col.label + '</span>' : '')
                            + '<span class="iv__card__meta-val">' + formatted + '</span>'
                            + '</div>');
                    }
                });
            } else if (data.data) {
                // Champs directs dans data
                const ignored = ['label', 'name', 'status', 'icon', 'id', 'class', 'cls', 'type'];
                $.each(data.data, (k, val) => {
                    if (metaRows.length >= 3) return;
                    if (!ignored.includes(k) && val !== undefined && val !== null && val !== '') {
                        metaRows.push('<div class="iv__card__meta-item">'
                            + '<span class="iv__card__meta-label">' + k + ':</span>'
                            + '<span class="iv__card__meta-val">' + val + '</span>'
                            + '</div>');
                    }
                });
            }
        }

        // 5. Description / Intro textuelle si présente
        let descHtml = '';
        const descVal = (data.data && (data.data.intro || data.data.preview || data.data.description))
            || data.intro || data.preview || data.description;
        if (descVal && typeof descVal === 'string' && !descVal.startsWith('http') && !descVal.startsWith('/')) {
            const strippedDesc = $('<div>').html(descVal).text().trim();
            if (strippedDesc) {
                const shortDesc = strippedDesc.length > 120 ? strippedDesc.substring(0, 117) + '...' : strippedDesc;
                descHtml = '<p class="iv__card__desc">' + shortDesc + '</p>';
            }
        }

        let countHtml = '';
        if (myself.shouldShowCount(data, this.name)) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = '<div class="' + currentClassAll + ' iv__item--card">'
            + '<div class="iv__item__frame iv__card">'
                + '<span class="iv__item__link">'
                    + (imageCode ? (
                        '<div class="iv__card__media ' + (hasCustomThumb ? 'iv__card__media--cover' : 'iv__card__media--icon') + '" style="height:' + imageHeight + 'px;' + (data.color ? 'background-color:' + data.color + ';' : '') + '">'
                        + '<span class="iv__item__image">' + imageCode + '</span>'
                        + (badgesHtml ? '<div class="iv__card__badges">' + badgesHtml + '</div>' : '')
                        + '</div>'
                    ) : '')
                    + '<div class="iv__card__body">'
                        + (!imageCode && badgesHtml ? '<div class="iv__card__badges iv__card__badges--inline">' + badgesHtml + '</div>' : '')
                        + '<label class="iv__item__label">'
                            + '<h4 class="iv__item__name iv__card__title titre">' + (data.label ? data.label : '&nbsp;') + countHtml + '</h4>'
                        + '</label>'
                        + (descHtml ? descHtml : '')
                        + (metaRows.length ? '<div class="iv__card__meta">' + metaRows.join('') + '</div>' : '')
                    + '</div>'
                + '</span>'
                + (codeActions.length ? '<div class="iv__card__footer">' + codeActions.join('') + '</div>' : '')
            + '</div>'
        + '</div>';

        const currentIcon = $(code);
        const currentIconReact = currentIcon.find('.iv__card__media, .iv__card__title');

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    getZoomLimits() {
        return { enabled: false };
    }
}
